import React, { useEffect, useState } from "react";
import { axios } from "../../lib/constants/api";
import { useParams } from "react-router-dom";
import "./invoice.style.scss";

export const InvoiceComponent: React.FC = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const [invoiceData, setInvoiceData] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchInvoiceData = async () => {
      try {
        const response = await axios.get(`/invoices/${invoiceId}`);
        if (isMounted) {
          setInvoiceData(response.data);
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error fetching invoice data:', error);
        }
      }
    };

    if (invoiceId) {
      fetchInvoiceData();
    }
    
    return () => {
      isMounted = false;
    };
  }, [invoiceId]);

  useEffect(() => {
    // Add the class when the component mounts
    document.body.classList.add("invoice");
    
    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove("invoice");
    };
  }, []);

  if (!invoiceData) return <div>Loading...</div>;

  const {
    invoiceNumber,
    status,
    seller,
    country,
    reseller,
    resellerCountry,
    createdAt,
    purchasedAt,
    products,
    details,
    others_costs: otherCosts = [],
  } = invoiceData;

  return (
    <div className="invoice-container">
      <div className="invoice-header">
        <div className="invoice-info">
          <div className="invoice-number">
            <span>شناسه: {invoiceNumber}</span>
            <span
              className={`status ${
                status === "ثبت شده" ? "status-registered" : ""
              }`}
            >
              {status}
            </span>
          </div>
          <div className="invoice-seller">
            <div>فروشنده: {seller}</div>
            <div>کشور: {country}</div>
            <div>نماینده فروش: {reseller}</div>
            <div>کشور نماینده فروش: {resellerCountry}</div>
          </div>
        </div>
        <div className="invoice-brand">
          <img
            src="https://imagedelivery.net/V5ATA0DR_GnXU4EaWbiBDw/027c0d0e-0528-43d3-4d9f-5d7b7526af00/w=200,h=52"
            alt=""
          />
          <div className="invoice-title">فاکتور خرید</div>
        </div>
        <div className="invoice-info">
          <div>تاریخ ایجاد: {createdAt}</div>
          <div>تاریخ خرید: {purchasedAt}</div>
        </div>
      </div>
      <div className="invoice-body">
        <table className="invoice-table">
          <thead>
            <tr>
              <th>قیمت نهایی</th>
              <th>قیمت</th>
              <th>وزن</th>
              <th>شناسه آرمان</th>
              <th>محصول</th>
            </tr>
          </thead>
          <tbody>
            {(products || []).map((product, index) => (
              <tr key={index}>
                <td>{product.actualPrice}</td>
                <td>{product.price}</td>
                <td>{product.weight}</td>
                <td>{product.sku}</td>
                <td>{product.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        <br />
        <table className="invoice-table">
          <thead>
            <tr>
              <th>نرخ تبدیل به یورو</th>
              <th>هزینه به یورو</th>
              <th>هزینه</th>
              <th>شیوه پرداخت</th>
              <th>شرح هزینه</th>
              <th>کارگذار</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {otherCosts.map((product, index) => (
              <tr key={index}>
                <td>{product.exchange_rate}</td>
                <td>{product.price_euro}</td>
                <td>
                  {product.price} {product.currency}
                </td>
                <td>{product.payment_method}</td>
                <td>{product.kind}</td>
                <td>{product.agent ? product.agent.name : "-"}</td>
                <td>{product.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <table className="invoice-table invoice-details">
          <tbody>
            <tr>
              <td>{details.currency}</td>
              <td>واحد پول</td>
            </tr>
            <tr>
              <td>{details.invoiceTotalPrice}</td>
              <td>مبلغ کل فاکتور</td>
            </tr>
            <tr>
              <td>{details.cash}</td>
              <td>پرداخت نقدی</td>
            </tr>
            <tr>
              <td>{details.commission}</td>
              <td>کمیسیون فروش</td>
            </tr>
            <tr>
              <td>{details.tax}</td>
              <td>مالیات و عوارض</td>
            </tr>
            <tr>
              <td>{details.finalPrice}</td>
              <td>مبلغ نهایی فاکتور</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
